<section class="carousel-section" data-pagination="true" #slider></section>
